export class BalanceManager {
	constructor(setup: BalanceManagerSetup) {
		this.model = (setup.jurisdiction == "spain") ? new SpanishBalance(setup.initialCredit as number[]) : new DefaultBalance(setup.initialCredit);
		this.denomination = setup.denomination
		if (!this.denomination) { this.denomination = 0.01; console.log("No denomination specified.") }
	}

	static CheckArrayValidity(array: number[]): boolean {
		if (Array.isArray(array) && array.length > 0) return true
		else return false
	}

	GetDenomination(): number {
		return this.denomination
	}

	SetCredit(value: number[]): void {
		this.model.SetCredit(value)
	}

	GetCredit(): number {
		return this.model.GetCredit()
	}

	UpdateCredit(value: number): void {
		this.model.UpdateCredit(value);
	}

	CreditToMoney(Credit: number): number {
		let result = 0

		if (Credit > 0)
			result = Credit * this.denomination

		return result
	}

	MoneyToCredit(Money: number): number {
		let result = 0

		if (Money > 0)
			result = Math.floor(Money / this.denomination)

		if (result < 1)
			result = 0

		return result
	}

	Credit(): number[] {
		return this.model.Credit();
	}

	GetCreditFromArray(value: number[]): number {
		return this.model.GetCreditFromArray(value);
	}

	CreateCreditArray(value: number): number[] {
		return this.model.CreateCreditArray(value);
	}

	private denomination: number
	private model: BalanceModel
}

export type BalanceManagerSetup = {
	denomination: number
	initialCredit: number[]
	jurisdiction: string
}

export class DefaultBalance implements BalanceModel {
	constructor(credit: number[]) {
		this.credit = credit;
	}

	static ZeroCredits: number[] = [0, 0, 0, 0, 0, 0]

	GetCredit(): number {
		return this.credit.reduce((total, num) => { return total + num })
	}

	SetCredit(value: number[]): void {
		//TODO: FOR now we set the 0 value, when we will define all else wil refactor this
		this.credit = value;
	}

	UpdateCredit(value: number): void {
		//TODO: FOR now we set the 0 value, when we will define all else wil refactor this
		this.credit[2] += value;
	}

	Credit(): number[] {
		return this.credit;
	}

	GetCreditFromArray(value: number[]): number {
		if (BalanceManager.CheckArrayValidity(value)) {
			return value.reduce((total, num) => { return total + num })
		} else {
			return 0
		}
	}

	CreateCreditArray(value: number): number[] {
		return [0, 0, value, 0, 0, 0];
	}

	Subtract(value: number[]): number[] {
		let toRet: number[] = new Array<number>(this.credit.length);
		this.credit.forEach((c, i) => {
			toRet.push(c - value[i])
		});
		return toRet;
	}

	credit: number[];
}

class SpanishBalance extends DefaultBalance {
	constructor(credit: number[]) {
		super(credit);
	}

	//TODO: When we know what spanish will do, will change this.
}

//TODO: refactor this to class
interface BalanceModel {
	GetCredit(): number
	GetCreditFromArray(value: number[]): number
	CreateCreditArray(value: number): number[]
	SetCredit(value: number[]): void
	UpdateCredit(value: number): void
	Credit(): number[]
	Subtract(value: number[]): number[]
	credit: number[]
}